import { IConfiguration, IOrganization, IUserData } from '../SuiteHeader.types';
import { fetchResourceTenants, fetchTenantName } from './apiHelper';

export const fetchAllTenants = async (configuration: IConfiguration, userData: IUserData) => {
  // Fetch resource tenants
  const resourceTenants = await fetchResourceTenants(configuration, userData);
  const tenantIds = resourceTenants.map(tenant => tenant.tenantId) ?? [];

  // Fetch tenant names in parallel, using Promise.allSettled to handle both resolved and rejected promises
  const tenantNamePromises = tenantIds.map(tenantId =>
    fetchTenantName(tenantId, configuration)
      .then(tenantInfo => ({
        tenantId: tenantInfo.tenantId,
        displayName: tenantInfo.displayName,
        isCurrent: tenantInfo.tenantId === userData.tenantId,
        isHome: tenantInfo.tenantId === userData.homeTenantId
      }))
      .catch(_error => null)
  ); // Use catch to handle and ignore errors

  // Use Promise.allSettled and filter out any rejected promises
  const results = await Promise.allSettled(tenantNamePromises);
  const tenantsInfo = results
    .filter(result => result.status === 'fulfilled' && result.value !== null)
    .map(result => (result as PromiseFulfilledResult<IOrganization>).value);

  return tenantsInfo;
};
